import { render, staticRenderFns } from "./editPayComputation.vue?vue&type=template&id=008164f2&scoped=true"
import script from "./editPayComputation.vue?vue&type=script&lang=js"
export * from "./editPayComputation.vue?vue&type=script&lang=js"
import style0 from "./editPayComputation.vue?vue&type=style&index=0&id=008164f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "008164f2",
  null
  
)

export default component.exports